import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';
import discountNS from './constants/discountOfferNS';
import { getUserId } from '../../localStorages';

export default data => {
  let newPriceOfferNS = discountNS;
  if (data && data.discountingModel === 'COMPLEX') {
    newPriceOfferNS = newPriceOfferNS.filter(item => item !== 'timeUnit');
  }
  const newData = data;
  newData.userId = getUserId() || newData.userId || null;
  const dataCreate = parseToMutationRequest(newData, newPriceOfferNS);
  const createDiscountOffer = `createDiscountOffer(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createDiscountOffer} {
      id
    }
  }
`;
};
